export type OperatorKey = 'eq' | 'not_eq' | 'cont' | 'not_cont';

export interface SelectOption {
  label: string;
  value: string;
}

export interface FilterProperty {
  label: string;
  value: string;
  operators: OperatorKey[];
  isBoolean?: boolean;
  options?: SelectOption[];
}

export interface FilterRowData {
  id: number;
  property: string;
  operator: string;
  value: string;
}

export type RansackSearch = Record<string, string>;

export const OPERATORS: Record<OperatorKey, string> = {
  cont: 'Contains',
  eq: 'Equals',
  not_cont: 'Not contains',
  not_eq: 'Not equals',
};

export const BOOLEAN_OPTIONS = [
  { label: 'True', value: 'true' },
  { label: 'False', value: 'false' },
];
